<template>
  <div class="wapper">
    <el-container style="100%">
      <TicketType @getTicketTypeId="getTicketTypeId"></TicketType>
      <el-main style="background: #fff; margin-left: 10px">
        <div class="box">
          <div class="table-wrap">
            <div class="handle-box3">
              <el-form
                :inline="true"
                ref="form"
                :model="searchForm"
                class="demo-form-inline handle-search"
              >
                <div class="uers-left">
                  <el-form-item label="搜索：">
                    <el-input
                      v-model="searchForm.name"
                      placeholder="姓名"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label>
                    <el-input
                      v-model="searchForm.code"
                      placeholder="码值"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label>
                    <el-input
                      v-model="searchForm.idNumber"
                      placeholder="编号"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label>
                    <el-select v-model="searchForm.projectDoor" placeholder="选择门禁点">
                      <el-option
                        v-for="(type, i) in ProjectDoor"
                        :key="i"
                        :label="type.name"
                        :value="type.name"
                      >
                        <div @click="getChangeDoorType(type)">
                          {{ type.name }}
                        </div>
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label>
                    <el-date-picker
                      v-model="searchForm.startDate"
                      type="datetime"
                      placeholder="开始日期"
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item label>
                    <el-date-picker
                      v-model="searchForm.endDate"
                      type="datetime"
                      placeholder="开始日期"
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item label>
                    <el-button
                      type="primary"
                      icon="el-icon-search"
                      @click="searchSubmit"
                      >搜索</el-button
                    >
                    <el-button
                      type="primary"
                      icon="el-icon-export"
                      @click="exportExcel"
                      >导出</el-button
                    >
                  </el-form-item>
                </div>
              </el-form>
            </div>
            <div class="tabbox">
              <el-table
                :data="dataList"
                height="100%"
                border
                class="table"
                ref="multipleTable"
                :header-cell-style="{ background: '#f2f6fc', color: '#606266' }"
                @selection-change="handleSelectionChange"
              >
                <el-table-column
                  type="selection"
                  width="55"
                  align="center"
                ></el-table-column>
                <el-table-column prop="name" label="名称" align="center">
                  <template slot-scope="scope">
                    <span>{{ scope.row.name }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="code" label="编号/码值" align="center"
                                 width="150">
                  <template slot-scope="scope">
                    <span>{{ scope.row.code }}</span><br/>
                    <span>{{ scope.row.idNumber }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="idNumber"
                    label="身份证"
                    align="center"
                    width="150"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.idCard }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="door" label="门禁点" align="center">
                  <template slot-scope="scope">
                    <span>{{ scope.row.door }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="time" label="年龄" align="center">
                  <template slot-scope="scope">
                    <span>{{ scope.row.type }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="time" label="性别" align="center">
                  <template slot-scope="scope">
                    <span>{{ scope.row.time }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="healthCode" label="省" align="center">
                  <template slot-scope="scope">
                    <span>{{ scope.row.healthCode }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="temperature" label="市" align="center">
                  <template slot-scope="scope">
                    <span>{{ scope.row.temperature }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="nucleicAcid" label="区" align="center">
                  <template slot-scope="scope">
                    <span>{{ scope.row.nucleicAcid }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="avatar" label="头像" align="center">
                  <template slot-scope="scope">
                    <div class="demo-image__preview">
                      <el-image
                          style="width: 40px; height: 40px"
                          :src="scope.row.avatar"
                          :preview-src-list="[scope.row.avatar]"
                      ></el-image>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="createDate"
                    label="创建时间"
                    align="center"
                    width="150"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.createDate }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="删除" width="180" align="center">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      class="red"
                      @click="handleDelete(scope.$index, scope.row)"
                      >删除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="fb">
              <el-pagination
                class="pag"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
              :page-sizes="[5, 10, 15, 20, 50, 100]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                background
              ></el-pagination>
            </div>
          </div>
        </div>
        <DeleteDialog
          :delVisible="delVisible"
          @deleteData="deleteData"
          @handleCloseVisible="handleCloseVisible"
        ></DeleteDialog>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import EditPapersManage from "../../../components/ticketing/certificate/EditPapersManage";
import TicketType from "../../../components/ticketing/ticket/TicketType";
import DeleteDialog from "../../../components/public/DeleteConfim";

export default {
  data() {
    return {
      total: 0, //总条数
      currentPage: 1, //初始页
      pagesize: 10, // 每页的数据
      //表格高度适配
      tabheight: "",
      label: "",
      labels: [],
      searchForm: {
        name: "",
        code: "",
        idNumber: "",
        projectDoor: "",
        ticketTypeId: 0,
        endDate: new Date(
          new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 -
            1
        ),
        startDate: new Date(
          new Date(new Date().toLocaleDateString()).getTime() -
            (new Date(new Date().toLocaleDateString()).getTime() -
              new Date(new Date().getFullYear().toString()))
        ),
      },
      delVisible: false,
      document_Id: "",
      dataList: [],
      multipleSelection: [],
      projectId: localStorage.getItem("project_Id"),
      ProjectDoor: [],
    };
  },
  mounted() {
    // this.tabheight=(this.$refs.getheight.offsetHeight-165)
  },
  created() {
    this.getData();
    this.getProjectDoor();
    this.getLabel();
  },
  methods: {
    delLabel() {},
    saveLabel() {},
    handleSizeChange(val) {
      this.pagesize = val;
      this.searchSubmit();
    },
    exportExcel() {
      var search = {
        name: this.searchForm.name,
        code: this.searchForm.code,
        idNumber: this.searchForm.idNumber,
        projectId: this.projectId,
        projectDoor: this.searchForm.projectDoor,
        projectDoorId: 0,
        ticketTypeId: this.searchForm.ticketTypeId,
        pageIndex: 0,
        startDate: this.searchForm.startDate,
        endDate: this.searchForm.endDate,
        pageSize: this.total,
      };
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$axios
        .post(`/AccessRecord/Ticket/Export`, search)
        .then((res) => {
          loading.close();
          if (res.data.data) {
             window.open(res.data.data, '_self');
            // this.$download(res.data.data, '导出证件.xlsx');
          } else {
            this.$message.error("导出失败");
          }
        })
        .catch((a) => {
          loading.close();
          this.$message.error("导出失败");
        });
    },
    getTicketTypeId(val) {
      this.searchForm.ticketTypeId = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.searchSubmit();
    },
    searchSubmit() {
      var search = {
        name: this.searchForm.name,
        code: this.searchForm.code,
        idNumber: this.searchForm.idNumber,
        projectId: this.projectId,
        projectDoor: this.searchForm.projectDoor,
        projectDoorId: 0,
        ticketTypeId: this.searchForm.ticketTypeId,
        pageIndex: this.currentPage - 1,
        startDate: this.searchForm.startDate,
        endDate: this.searchForm.endDate,
        pageSize: this.pagesize,
      };
      this.$axios.post("/AccessRecord/Ticket/Search", search).then((res) => {
        if (res.data.hasError == false) {
          this.dataList = [...res.data.data];
          this.total = res.data.total;
        }
      });
    },
    // 获取数据
    getData() {
      this.currentPage = 1;
      this.searchSubmit();
    },
    handleDelete(index, row) {
      this.document_Id = row.accessRecordId;
      this.delVisible = true;
    },
    deleteData() {
      this.$axios.delete(`/AccessRecord/${this.document_Id}`).then((res) => {
        if (res.data.hasError) {
          this.$message.error(res.data.message);
        } else {
          this.$message.success("删除成功！");
          this.delVisible = false;
          this.getData();
        }
      });
    },
    getChangeDoorType(type) {
      this.searchForm.projectDoorId = type.projectDoorId;
    },
    getProjectDoor() {
      this.$axios.get("/ProjectDoor/").then((res) => {
        if (res.data.hasError == false) {
          this.ProjectDoor = [...res.data.data];
        }
      });
    },
    getLabel() {
      this.$axios.get("/Label/Project/" + this.projectId).then((res) => {
        if (res.data.hasError == false) {
          this.labels = [...res.data.data];
        }
      });
    },
    handleCloseVisible() {
      this.document_Id = "";
      this.delVisible = false;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
  components: {
    EditPapersManage,
    TicketType,
    DeleteDialog,
  },
};
</script>
<style lang="scss" scope>
.pag {
  position: absolute;
  bottom: 0;
}
.box {
  height: 100%;
}
.handle-box3 {
  padding-top: 10px;
}
.uers-left {
  width: 100%;
}
.uers-right {
  width: 100%;
}
.table-wrap {
  margin-left: 10px;
  height: 100%;
}
.el-main {
  border-radius: 5px;
  position: relative;
}
.handle-search {
  display: flex;
  justify-content: space-between;
}
</style>